import { ITerminationReasonResponse } from "@modules/accounts/interfaces";
import { ITerminationReasons } from "../interfaces/models/ITerminationReasons";

export const mapTerminationReasons = (reasonsResponses: ITerminationReasonResponse[]): ITerminationReasons =>
    reasonsResponses.reduce((acc, response) => {
        acc[response.primaryReason] = response.secondaryReasons.map((res) => res.reason);

        return acc;
    }, {} as ITerminationReasons);
